<div class="notification-container">
    @for (notification of notificationService.notificationsSubject | async; track notification) {
        <div
            class="notification"
            [ngClass]="{
                '-dismissible': notification.dismissible,
                '-success': notification.type == 'success',
                '-warning': notification.type == 'warning',
                '-critical': notification.type == 'critical',
                '-info': notification.type == 'info',
            }"
        >
            @if (notification.dismissible) {
                <button
                    type="button"
                    class="button"
                    (click)="notificationService.removeNotification(notification)"
                >
                    <span>&times;</span>
                </button>
            }
            <span [innerHtml]="notification.message"></span>
        </div>
    }
</div>
